import graph from './graph';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { Card, Stack, Avatar, CardHeader, Typography, CircularProgress } from '@mui/material';

export default function NotificationContent() {
  const { userToken } = useSelector((state) => state.auth);

  const { data, loading } = useQuery(graph.notes.query, {
    variables: {
      limit: 8,
    },
    context: {
      serviceName: graph.notes.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const res = data ? data[graph.notes.name]?.data : [];

  if (loading) {
    return <Loading />;
  }
  if (res.length > 0) {
    return <Model data={res} />;
  }

  return <NoData title="پیامی یافت نشد!" />;
}

function Model({ data }) {
  // return <PushSubscription />;
  return data.map(({ id, content, type }) => {
    const { title, subtitle, body, icon, image, click_action } = JSON.parse(content);
    return (
      <Card elevation={1} key={id}>
        {/* <CardMedia sx={{ pt: "10%" }} image={icon}></CardMedia> */}
        <CardHeader avatar={<Avatar alt={title} src={icon} />} title={title} subheader={body} />
      </Card>
    );
  });
}

function Loading() {
  return (
    <Stack alignItems="center" justifyContent="center">
      <CircularProgress />
    </Stack>
  );
}

function NoData({ title }) {
  return (
    <Stack alignItems="center" justifyContent="center">
      {/* <Image
        width={140}
        height={140}
        style={{ margin: "auto" }}
        alt="push-notifications"
        src="/assets/images/push-notifications.jpg"
      /> */}
      <Typography variant="caption" color="text.disabled">
        {title}
      </Typography>
    </Stack>
  );
}
